import React from "react";
import { Card } from "antd";
import PublicHeader from "../Header/PublicHeader";
import Footer from "../Footer";
import { Link } from "react-router-dom";

const TermsConditions = () => {
  return (
    <>
    <PublicHeader />
    <div className="container mx-auto p-6">
      <div className="container  rounded-lg p-6 text-justify mx-auto" style={{ textWrap: 'pretty' }}>
        <h1 className="text-3xl font-bold mb-4 text-center text-[#0d73b9]">
          Terms & Conditions
        </h1>
        <p className="text-gray-600  mb-6">
          Welcome to the website of the <strong>Association of Professional Career Counsellors of India (APCCI)</strong>. 
          By accessing or using our website (<a href="https://www.apcci.in" className="text-blue-600 font-semibold">www.apcci.in</a>), 
          you agree to comply with and be bound by the following terms and conditions. If you do not agree with these terms, 
          please do not use our website.
        </p>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">1. General Use</h2>
          <ul className="list-disc list-inside text-gray-700">
            <li>The content on this website is for informational and educational purposes only.</li>
            <li>APCCI reserves the right to modify, update, or discontinue any part of the website at any time without prior notice.</li>
            <li>Unauthorized use of this website may give rise to a legal claim for damages or be a criminal offense.</li>
          </ul>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">2. Membership & Services</h2>
          <ul className="list-disc list-inside text-gray-700">
            <li>Membership is available only to certified career counsellors who meet APCCI’s eligibility criteria.</li>
            <li>All membership fees, events, training, or certifications are non-refundable unless stated otherwise.</li>
            <li>APCCI reserves the right to accept, reject, or terminate memberships or services if fraudulent practices are detected.</li>
          </ul>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">3. Intellectual Property</h2>
          <p className="text-gray-700">
            All content, including text, images, logos, and other materials, is the property of APCCI and protected by copyright and trademark laws.
          </p>
          <p className="text-gray-700">
            Members and users may not reproduce, distribute, or modify any content without prior written permission from APCCI.
          </p>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">4. Code of Conduct</h2>
          <ul className="list-disc list-inside text-gray-700">
            <li>Users must behave professionally and respectfully when interacting with APCCI’s online and offline platforms.</li>
            <li>Any misuse of APCCI’s resources, defamation, or misconduct may result in immediate termination of access.</li>
            <li>APCCI reserves the right to take action against any user violating ethical guidelines.</li>
          </ul>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">5. Limitation of Liability</h2>
          <p className="text-gray-700">
            APCCI does not guarantee the accuracy, completeness, or suitability of the information provided on this website.
          </p>
          <p className="text-gray-700">
            APCCI is not responsible for any direct, indirect, or incidental damages resulting from the use of this website or services.
          </p>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">6. Third-Party Links</h2>
          <p className="text-gray-700">
            Our website may contain links to third-party websites. These links are provided for convenience, and
            <span className="text-blue-600 font-semibold">
              {" "}APCCI does not endorse or take responsibility for their content.
            </span>
          </p>
          <p className="text-gray-700">
            Users access third-party websites at their own risk.
          </p>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">7. Privacy & Data Protection</h2>
          <p className="text-gray-700">
            By using this website, you agree to APCCI’s <span className="text-blue-600 font-semibold">Privacy Policy</span>, which outlines how we collect, store, and use your data.
          </p>
          <p className="text-gray-700">
            We implement reasonable measures to protect your information but do not guarantee absolute security.
          </p>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">8. Termination of Access</h2>
          <ul className="list-disc list-inside text-gray-700">
            <li>APCCI reserves the right to suspend or terminate any user’s access to the website if they violate these terms.</li>
            <li>Content that is engaging in unethical or illegal activities will be removed without notice.</li>
          </ul>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">9. Changes to Terms & Conditions</h2>
          <p className="text-gray-700">
            APCCI may update these Terms at any time without prior notice. Continued use of the website after changes are posted constitutes acceptance of the revised terms.
          </p>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">10. Governing Law & Jurisdiction</h2>
          <p className="text-gray-700">
            Any disputes arising from website use shall be subject to the jurisdiction of the courts in Delhi, India.
          </p>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">11. Contact Us</h2>
          <p className="text-gray-700">
            For any queries regarding these Terms & Conditions, please reach out to us at:
          </p>
          <p >Email:<b> dgoffice@apcci.in </b></p>
                    <p className="font-semibold">
            Or click to <Link to="/contact-us" className="text-blue-500 underline">Contact us</Link>
          </p>
        </div>

        <p className="text-gray-700 text-center mt-6">
          By using our website, you agree to abide by these Terms & Conditions.
        </p>

        <p className="text-center font-bold mt-4">
          - Association of Professional Career Counsellors of India (APCCI)
        </p>
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default TermsConditions;
